import AuctionsCatalog from './auctions_catalog';
import Artworks from './artworks';
import User from './user';

export default {
  AuctionsCatalog,
  Artworks,
  User,
};



// WEBPACK FOOTER //
// ./app/javascript/packs/auctions_catalogs/show/resources/index.js